<template>
    <div style="width: 100%;height: 100%">
        <div class="selectors-section">
            <div class="selector-item">
                <el-form :model="inputsInfo" label-width="130px"  ref="inputsForm" label-position="top"
                    style="width: 90%;margin: 10px auto;">
                    <template v-for="(item, index) in user_input_form">
                        <el-form-item :label="item['text-input'].label" :prop="item['text-input'].variable"
                            style="margin-bottom: 10px;" v-if="item && item['text-input']">
                            <el-input v-model="inputsInfo[item['text-input'].variable]" placeholder="请输入"
                                style="width:100%;"></el-input>
                        </el-form-item>
                        <el-form-item :label="item.number.label" :prop="item.number.variable"
                            style="margin-bottom: 10px;" v-if="item && item.number">
                            <el-input type="number" v-model="inputsInfo[item.number.variable]" placeholder="请输入"
                                style="width:100%;"></el-input>
                        </el-form-item>
                        <el-form-item :label="item.paragraph.label" :prop="item.paragraph.variable"
                            style="margin-bottom: 10px;" v-if="item && item.paragraph">
                            <el-input type="textarea" :rows="5" v-model="inputsInfo[item.paragraph.variable]"
                                placeholder="请输入" style="width:100%;"></el-input>
                        </el-form-item>
                        <el-form-item :label="item.select.label" :prop="item.select.variable"
                            style="margin-bottom: 10px;" v-if="item && item.select">
                            <el-select v-model="inputsInfo[item.select.variable]" placeholder="请选择" style="width:100%;">
                                <el-option v-for="(option, idx) in agentVarObj[item.select.variable].options" :key="idx"
                                    :label="option.text" :value="option.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import { } from "../../api/api"
import qs from 'qs';
export default {
    name: 'agentKey',
    components: {

    },
    props: {
        user_input_form: {
            default: ""
        },
        inputsInfo: {
            default: {}
        },
        agentVarObj:{
            default: ""
        }
    },

    data() {
        return {
            rules:[],
            keyboradHeightKey: null,
            viewkeyboradHeight: 0,
            keyboradHeight: 0,
            inputs: {}, //表单值
            agentVar: {}, //表单中的options,和rule规则校验
        };
    },
    computed: {

    },
    watch: {
        inputs: {
            handler(newVal, oldVal) {
                this.$emit('inputsInfoChange', newVal);
            },
            deep: true
        },
        user_input_form: {
            handler(newVal, oldVal) {
                // if (!newVal) return
                console.log(newVal);
                // newVal.forEach((item, index) => {
                //     if (item.select) {
                //         this.$set(this.inputs,item.select.variable,item.select.default)
                //         this.$set(this.agentVar,item.select.variable,{
                //             options: [],
                //             rule: '',
                //             required: false
                //         })
                //         this.agentVar[item.select.variable].options = item.select.options.map(items => {
                //             return {
                //                 text: items,
                //                 value: items
                //             }
                //         })
                //         this.agentVar[item.select.variable].rule = '请选择' + item.select.label
                //         this.agentVar[item.select.variable].required = item.select.required
                //     }
                //     if (item.paragraph) {
                //         this.inputs[item.paragraph.variable] = item.paragraph.default;
                //         this.$set(this.inputs,item.paragraph.variable,item.paragraph.default)
                //         this.agentVar[item.paragraph.variable] = {
                //             rule: '',
                //             required: false
                //         }
                //         this.agentVar[item.paragraph.variable].rule = '请选择' + item.paragraph.label
                //         this.agentVar[item.paragraph.variable].required = item.paragraph.required
                //     }
                //     if (item['text-input']) {
                //         this.inputs[item['text-input'].variable] = item['text-input'].default;
                //         this.$set(this.inputs,item['text-input'].variable,item['text-input'].default)
                //         this.agentVar[item['text-input'].variable] = {
                //             rule: '',
                //             required: false
                //         }
                //         this.agentVar[item['text-input'].variable].rule = '请选择' + item['text-input'].label
                //         this.agentVar[item['text-input'].variable].required = item['text-input'].required
                //     }
                //     if (item.number) {
                //         this.inputs[item.number.variable] = item.number.default;
                //         this.$set(this.inputs,item.number.variable,item.number.default)
                //         this.agentVar[item.number.variable] = {
                //             rule: '',
                //             required: false
                //         }
                //         this.agentVar[item.number.variable].rule = '请选择' + item.number.label
                //         this.agentVar[item.number.variable].required = item.number.required
                //     }
                    // this.$set(this,'inputs',this.inputs)
                    // this.triggerEvent('agentVarChange', {
                    //     value: this.data.agentVar,
                    // });
                // })

            },
            deep: true
        },
        inputsInfo: {
            handler(newVal, oldVal) {
                console.log(newVal);
                if (newVal) {
                    // this.inputs = newVal;
                    this.$emit('inputsInfoChange', newVal);
                    // console.log(newVal);
                }
            },
            deep: true
        },

    },
    created() {

    },
    mounted() {

    },
    methods: {


    }
};
</script>
<style scoped>
.selectors-section {
    background-color: white;
    border-radius: 20px;
    padding: 15px 20px;
    margin-bottom: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}

.selector-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 16px;
}

.selector-item:last-child {
    margin-bottom: 0;
}
</style>